import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import { SearchModeEnum } from "common/enums/SearchModeEnum";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import React from "react";
import styles from "./ModeSelectDialog.module.scss";
import { useModeSelectDialogHooks } from "./hooks";
import { ModeSelectDialogProps } from "./interfaces";

export const ModeSelectDialog = React.memo((props: ModeSelectDialogProps) => {
  const { mode, busy, onModeClick, onOkClick } =
    useModeSelectDialogHooks(props);

  return (
    <>
      <Dialog
        style={props.style}
        className={`${props.className} ${styles.dialog}}`}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="mode-select-title"
        aria-describedby="mode-select-description"
        fullWidth
        slotProps={{
          paper: { className: styles.dialogPaper },
          backdrop: { className: styles.backdrop }
        }}
      >
        <DialogHeader id="mode-select-title" icon={<PanToolAltIcon />} />
        <DialogContent id="mode-select-description">
          <Box className={styles.paragraph}>
            <Box
              className={`${styles.button} ${
                mode === SearchModeEnum.all ? styles.on : styles.off
              }`}
              onClick={onModeClick}
            >
              {SearchModeEnum.all}
            </Box>
            <Box
              className={`${styles.button} ${
                mode === SearchModeEnum.domain ? styles.on : styles.off
              }`}
              onClick={onModeClick}
            >
              {SearchModeEnum.domain}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            variant="contained"
            className={styles.cancelButton}
            disabled={busy}
            onClick={props.onCloseClick}
          >
            キャンセル
          </Button>
          <Button
            variant="contained"
            className={styles.okButton}
            disabled={busy}
            onClick={onOkClick}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});
